module.exports = __webpack_public_path__ + "media/metronic/_theme/media/flags/046-micronesia-3d2cffec5ac0ea5d696b9a42451ec763.svg";